module.exports = __webpack_public_path__ + "media/images/athletes/3476-a5f24c0f4064c65328c103a3861ff335.png";